export const setLocalStorage = (name, value = {}) => {
    localStorage.setItem(name, value);
};

export const getLocalStorage = (name) => {
    const value = localStorage.getItem(name);
    return value ??  undefined;
};

export const removeLocalStorage = (name) => {
    localStorage.removeItem(name);
};
